import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDzxZi9wPlsmu35a7zWZqz5xyZwa6WayQ4",
  authDomain: "pilates-app-project.firebaseapp.com",
  databaseURL: "https://pilates-app-project-default-rtdb.firebaseio.com",
  projectId: "pilates-app-project",
  storageBucket: "pilates-app-project.firebasestorage.app",
  messagingSenderId: "885375361304",
  appId: "1:885375361304:web:438419c1acdfc9952abe6d",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);